import React, { useCallback, useContext, useEffect } from 'react'
import miscUtils from 'utils/miscUtils';
import { SetupBoardContext } from '../SetupBoard/SetupBoard';
import {
    // adminProfileCompleted,
    // calendarBooked,
    channelCreated,
    // contentPublished,
    coursesPublished,
    // customizeBranding,
    // customizeCommunitySettings,
    homePageActivated,
    invitePageConfigured,
    // libContentPublished,
    membersAdded,
    // membershipQuestionsConfigured,
    membershipSubscriptionSetup,
    productTourWatched,
    publishedEvents,
} from './utils';

export interface IOnboardingProgressPercentage {
    groupData: any,
    itemsLength: number
    compSelected: number
    hasCustomEmailSet?: boolean
    stepsDone: number
    setStepsDone: (stepsDone: number) => void,
}

const OnboardingProgressPercentage: React.FC<IOnboardingProgressPercentage> = React.memo(({
    groupData, itemsLength, compSelected, stepsDone, setStepsDone
}) => {
    const { courseExists, membershipQuestionsConfigured, workflowExists, landingPagesExists } = useContext(SetupBoardContext)

    const getStepsDone = useCallback(() => {
        let doneSteps = 0;
        if (groupData && miscUtils.isAdmin(groupData.user_membership)) {

            // Welcome
            if (compSelected === 5) {
                if (productTourWatched(groupData)) doneSteps++
            }

            // homepage setup
            if (compSelected === 0) {
                if (homePageActivated(groupData)) doneSteps++;
            }

            // channel setup
            if (compSelected === 1) {
                if (channelCreated(groupData)) doneSteps++;
            }

            // Onboarding Members config
            if (compSelected === 3) {
                if (membershipQuestionsConfigured()) { doneSteps++ };

                if (invitePageConfigured(groupData)) { doneSteps++ };

            }

            // courses base
            if (compSelected === 4) {
                if (courseExists) {
                    doneSteps++;
                }

                if (coursesPublished(groupData)) {
                    doneSteps++;
                }

            }

            // Events
            if (compSelected === 6) {
                if (publishedEvents(groupData)) doneSteps++;

            }

            // workflow
            if (compSelected === 7) {
                if (workflowExists && workflowExists.exists) {
                    doneSteps++;
                }

                if (workflowExists && workflowExists.isActive) {
                    doneSteps++;
                }

            }

            // landing pages
            if (compSelected === 8) {
                if (landingPagesExists && landingPagesExists.exists) {
                    doneSteps++;
                }

                if (landingPagesExists && landingPagesExists.isActive) {
                    doneSteps++;
                }

            }

            // adding members
            if (compSelected === 9) {
                if (membersAdded(groupData)) doneSteps++;
            }


            // community's subscriptions setup
            if (compSelected === 2) {
                if (membershipSubscriptionSetup(groupData)) {
                    doneSteps++;
                }
            }
        }
        setStepsDone(doneSteps);
    }, [groupData, setStepsDone, membershipQuestionsConfigured()]);

    useEffect(() => {
        getStepsDone()
    }, [getStepsDone, groupData]);

    return (
        <div className='progress-perc'>
            {Math.round((stepsDone / itemsLength) * 100)}%
        </div>
    )
});

export default OnboardingProgressPercentage;
